import CardTable from 'components/CardTable/CardTable'
import React, { useState, useEffect } from 'react'
import { TableInputs } from "components/CardTable/TableInputs";
import { useSelector } from 'react-redux'
import { columns } from './columns'
import { setStationConfigurationsFilters } from 'redux/actions/stationConfigurations/stationConfigurationsActions'
import { Description } from '@mui/icons-material'
import { useValidateReload } from "hooks/useValidateReload";
import { useSearch } from "hooks/useSearch";
const tableKey = "stationConfigurations";
const loadings = ["loadingStations", "loadingStationsActions"];

export const StationConfigurations = () => {
    const { company } = useSelector(({ stationConfig }) => stationConfig)
    const { stationsList, companiesList } = useSelector(({ companies }) => companies);
    const [stationsConfig, setStationsConfig] = useState([])
    const { isLoadingComp, configTables } = useSelector(({ search }) => search);
    const { buildTableConfig,  } = useSearch();

    useValidateReload(loadings);
    useEffect(() => {
        !configTables[tableKey] && buildTableConfig(tableKey);
    }, []);

    useEffect(() => {
        company?.stations ?
            setStationsConfig(company.stations)
            : setStationsConfig(stationsList)
    }, [stationsList, company, companiesList]);

    return (
        <CardTable
            hasHeader
            icon={<Description />}
            blockBtn
            title="Planta Inventario Digital"
            columns={columns}
            data={stationsConfig}
            isLoading={isLoadingComp?.loadingStations}
            tableContent={
                <TableInputs
                    reducer="stationConfig"
                    companies
                    dispatchAction={setStationConfigurationsFilters}
                    blockBtn
                    submitButtonShow={false}
                />
            }
        />
    )
}